var _path, _path2, _g, _path3, _path4, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTotalTradingVolume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12425_25393)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.563C0.082 13.978 0.147 13.389 0.25 12.807C0.624731 10.6797 1.4805 8.66615 2.752 6.92C2.782 6.88 2.819 6.844 2.875 6.78L6.955 9.83C4.832 13.294 4.454 16.903 6.208 20.575C7.963 24.251 11.007 26.228 15.041 26.759V31.889C14.566 31.849 14.092 31.837 13.626 31.769C8.207 30.981 4.419 27.937 1.891 23.202C0.82 21.198 0.223 19.04 0.052 16.77C0.045 16.678 0.018 16.59 0 16.5V14.563Z",
    fill: "#03F5AE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12425_25393",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0,
    width: 28,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.02344 0H31.9984V14.976H4.02344V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12425_25393)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9984 14.973H29.9194C28.9834 14.973 28.0464 14.971 27.1094 14.976C26.9354 14.976 26.8214 14.964 26.8024 14.739C26.4744 10.898 24.4504 8.185 21.1094 6.439C18.2464 4.942 15.2334 4.637 12.1394 5.695C10.6764 6.195 9.42444 7.035 8.36144 8.158C8.29744 8.226 8.22544 8.287 8.13144 8.376L4.02344 5.298C4.83935 4.28454 5.79526 3.39227 6.86244 2.648C9.90344 0.538001 13.2934 -0.246999 16.9514 0.0660009C20.7014 0.388001 24.0294 1.759 26.8774 4.225C29.6134 6.595 31.2954 9.57 31.8274 13.168C31.9144 13.749 31.9404 14.34 31.9984 14.973Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9531 26.824C17.8771 26.589 18.8031 26.447 19.6591 26.12C23.6271 24.6 25.9911 21.723 26.7361 17.534C26.8591 16.842 26.8411 16.839 27.5461 16.839H31.9431C31.6781 24.569 25.0981 31.511 16.9531 31.851V26.824Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3172 19.979V11.792C14.3172 11.102 14.5442 10.877 15.2312 10.877C15.8042 10.877 16.3762 10.872 16.9482 10.878C17.3982 10.884 17.6732 11.15 17.6732 11.598C17.6782 14.354 17.6752 17.11 17.6742 19.866C17.6742 19.896 17.6662 19.926 17.6582 19.979H14.3172ZM12.5632 19.996C11.6252 19.996 10.7232 20.007 9.82015 19.991C9.661 19.9845 9.5107 19.916 9.40138 19.8002C9.29207 19.6843 9.23241 19.5303 9.23515 19.371C9.2237 17.947 9.2237 16.523 9.23515 15.099C9.23815 14.734 9.50015 14.48 9.88115 14.469C10.5562 14.449 11.2322 14.45 11.9072 14.469C12.2892 14.479 12.5562 14.732 12.5582 15.093C12.5692 16.714 12.5632 18.335 12.5632 19.996ZM19.4321 16.69C19.4372 16.327 19.7092 16.064 20.0752 16.056C20.7184 16.0367 21.3621 16.04 22.0051 16.066C22.5991 16.096 22.7952 16.326 22.7972 16.919C22.7992 17.709 22.7931 18.497 22.7822 19.287C22.7762 19.69 22.5192 19.988 22.1422 19.994C21.2502 20.008 20.3582 19.999 19.4272 19.999C19.4272 18.869 19.4181 17.779 19.4321 16.689V16.69Z",
    fill: "#03F5AE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12425_25393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalTradingVolume);
export default __webpack_public_path__ + "static/media/total_trading_volume.9b817d2d3919157e27767ab86305db93.svg";
export { ForwardRef as ReactComponent };